import styled, { css } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

import { colors } from 'global/colors';

export const CommunityCardGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;

  @media (max-width: 1366px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const CommunityCardContainer = styled.div`
  box-shadow: 0px 2px 8px 0px rgba(11, 18, 30, 0.08);
  min-width: 285px;
  height: 300px;
  border-radius: 16px;
  background: ${({ theme }) => theme.communityList.cardBackground};
  position: relative;
  transform: scale(1);
  transition: all 0.25s ease-in-out;

  :hover {
    transform: scale(1.02);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
    animation-fill-mode: forwards;
  }

  ${({ isCourse }) =>
    isCourse &&
    css`
      height: 275px;
    `}
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 5px;
`;

export const NameAndRatingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Link = styled(RouterLink)`
  text-decoration: none;
  color: unset;

  :hover {
    color: unset;
    text-decoration: none;
  }
`;

export const Image = styled.div`
  position: relative;
  width: 100%;
  height: 180px;
  border-radius: 16px 16px 0px 0px;
  background-image: url(${({ image }) => image || ''});
  background-size: cover;
  background-position: center center;
`;

export const SponsorImage = styled.img`
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 4px;
  width: 94px;
  height: 38px;
  background-color: white;
  border-radius: 5px;
`;

export const CardName = styled.div`
  font-size: 18px;
  color: ${({ theme }) => theme.communityList.selectedColor};
  font-weight: 600;
  line-height: 26.1px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: pre;
  margin-top: 5px;
  width: 80%;
`;

export const Rating = styled.div`
  color: ${({ theme }) => theme.communityList.color};
  font-size: 15px;
`;

export const Icon = styled.i.attrs((className) => ({ className: className }))`
  ${({ checkMarkIcon }) =>
    checkMarkIcon &&
    css`
      margin-right: 8px;
      font-size: 18px;
      color: ${({ theme }) => theme.communityList.tagColor};
    `}
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  gap: 10px;

  ${({ isEmptyTag }) =>
    isEmptyTag &&
    css`
      display: list-item;
    `}
`;

export const Tag = styled.div`
  background: ${colors.fsDarkBlue};
  border-radius: 12px;
  font-size: 14px;
  padding: 2px 10px 2px 10px;
  color: ${({ theme }) => theme.communityList.tagColor};
  background: ${({ theme }) => theme.communityList.tagBackground};
  text-transform: uppercase;

  ${({ isDifficultyTag }) =>
    isDifficultyTag &&
    css`
      color: ${({ theme }) => theme.communityList.difficultyTagColor};
      background: ${({ theme }) => theme.communityList.difficultyTagBackground};
    `}
`;

export const CompletionContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.communityList.color};
  font-size: 14px;
`;
